import axios from 'axios';

import { Config } from '../domain/config';

const path = '/qualification';

const getConfigurations = (): Promise<Config> => axios.get<Config>(`${path}/config`).then((res) => res.data);

export { getConfigurations };
